export const LAUNCH_DATE = new Date(2018, 4, 1);



// WEBPACK FOOTER //
// ./app/modules/HighScores/constants.js